<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-hidden">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Close dialog" (click)="closeMessageToCustomerViewDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Scrollable content area (includes title and content) -->
    <div class="flex-grow-1 overflow-auto d-flex flex-column align-items-center px-3 pt-4 px-md-4 pt-md-5 gap-3 w-100">
        <!-- Title - different for each state -->
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0 text-green" [class.zx-ltr]="!isRTL">
            <span *ngIf="state === 'messageToCustomer'">
                {{ messageToCustomer?.title }}
            </span>
            <span *ngIf="state === 'messageToHelpPt' && !isSuccess">
                {{ "printing-table.help-and-get-points.title" | translate }}
            </span>
            <span *ngIf="state === 'messageToHelpPt' && isSuccess">
                {{ "printing-table.help-and-get-points.success-title" | translate }}
            </span>
        </h4>

        <div class="d-flex flex-column gap-3 align-items-center w-100 pt-3">
            
            <!-- Content - only for messageToCustomer -->
            <div *ngIf="state === 'messageToCustomer'" class="w-100 text-center pb-4" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
                <p class="mb-0" style="white-space: pre-wrap;">
                    {{ messageToCustomer?.content }}
                </p>
            </div>

            <!-- Content - for messageToHelpPt (before success) -->
            <div *ngIf="state === 'messageToHelpPt' && !isSuccess" class="w-100 d-flex flex-column gap-3 pb-4" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
                <!-- Subtitle -->
                <h5 class="fw-bold m-0" [class.zx-ltr]="!isRTL" [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ "about-us.how-it-works" | translate }}
                </h5>
                
                <!-- Step 1 -->
                <p class="mb-0" style="white-space: pre-wrap;" [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ "printing-table.help-and-get-points.step1" | translate }}
                </p>
                
                <!-- Step 2 -->
                <p class="mb-0" style="white-space: pre-wrap;" [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ "printing-table.help-and-get-points.step2" | translate }}
                </p>
                
                <!-- Step 3 -->
                <p class="mb-0" style="white-space: pre-wrap;" [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                    {{ "printing-table.help-and-get-points.step3" | translate }}
                </p>
            </div>

            <!-- Content - for messageToHelpPt (success state) -->
            <div *ngIf="state === 'messageToHelpPt' && isSuccess" class="w-100 text-center pb-4" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
                <p class="mb-0" style="white-space: pre-wrap;">
                    {{ "printing-table.help-and-get-points.success-message" | translate }} {{ successPhoneNumber }}
                </p>
            </div>

            <!-- Phone field - only for messageToHelpPt and not success -->
            <form *ngIf="state === 'messageToHelpPt' && !isSuccess" class="w-100 d-flex flex-column gap-2" [formGroup]="form">
                <mat-form-field class="flex-grow-1 position-relative zx-z-index-1 zx-min-h-phone-input" [class.zx-ltr]="!isRTL">
                    <mat-label>
                        {{ "printing-table.help-and-get-points.phone-label" | translate }}
                    </mat-label>
                    <input matInput type="text" formControlName="phone"
                        [placeholder]="'printing-table.help-and-get-points.phone-label' | translate" 
                        appPhoneFormatDialog
                        [class.zx-ltr]="!isRTL" inputmode="numeric">
                    <mat-error *ngIf="form.get('phone').invalid && form.get('phone').touched" 
                        [class.zx-text-white]="isDarkMode"
                        [ngClass]="isRTL ? 'text-end zx-rtl' : 'text-start zx-ltr'">
                        {{ "my-profile.phone.error" | translate }}
                    </mat-error>
                </mat-form-field>
            </form>
        </div>
    </div>

    <!-- Fixed buttons at bottom (outside scrollable area) -->
    <div class="flex-shrink-0 d-flex flex-column flex-lg-row flex-grow-lg-1 justify-content-center align-items-end w-100 gap-3 px-3 pb-3 px-md-4">
        <!-- Buttons - before success -->
        <div *ngIf="!isSuccess" class="d-flex flex-column flex-lg-row flex-grow-lg-1 justify-content-center align-items-end w-100 gap-3">
            <button color="primary" mat-raised-button 
                (click)="state === 'messageToCustomer' ? openWhatsApp() : joinDistributionList()"
                [disabled]="(state === 'messageToHelpPt' && !isPhoneValid()) || isLoading"
                class="text-white rounded-pill zx-btn-single col-12 col-lg-6 fw-bold order-1 order-lg-1">
                <span *ngIf="state === 'messageToCustomer'">
                    {{ 'order-complited.printed.title.sub.problme-btn' | translate }}
                </span>
                <span *ngIf="state === 'messageToHelpPt' && !isLoading">
                    {{ "printing-table.help-and-get-points.join-list" | translate }}
                </span>
                <span *ngIf="state === 'messageToHelpPt' && isLoading">
                    {{ "printing-table.help-and-get-points.loading" | translate }}
                </span>
            </button>
            <button (click)="closeMessageToCustomerViewDialog()" color="primary" mat-button
                class="rounded-pill zx-btn-single col-12 col-lg-6 fw-bold order-2 order-lg-2">
                {{ "close-branch.btn" | translate }}
            </button>
        </div>

        <!-- Buttons - success state -->
        <div *ngIf="isSuccess" class="d-flex flex-column flex-lg-row flex-grow-lg-1 justify-content-center align-items-end w-100 gap-3">
            <button color="primary" mat-raised-button 
                (click)="closeMessageToCustomerViewDialog()"
                class="text-white rounded-pill zx-btn-single col-12 col-lg-6 fw-bold order-1 order-lg-1">
                {{ "close-branch.btn" | translate }}
            </button>
            <button (click)="unsubscribeFromDistributionList()" color="primary" mat-button
                class="rounded-pill zx-btn-single col-12 col-lg-6 fw-bold order-2 order-lg-2">
                {{ "printing-table.help-and-get-points.unsubscribe" | translate }}
            </button>
        </div>
    </div>

</div>

